import React, { useState, useEffect } from 'react';
import { Glyphicon } from 'react-bootstrap';
import { ArrowWrapper, StepWrapper } from './styles';
import { IApplicationState, IAppState } from '@nkr/store/index';
import { connect, Dispatch } from 'react-redux';


interface IProps {
    currentStep: number,
    campaignId: number
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {}

type TProps = IProps & IStateProps & IDispatchProps;

const CampaignSteps = ({currentStep, campaignId, app}:TProps) => {

    let steps = ['Create Campaign', 'Upload Mailing List', 'Define Column Mapping', 'Confirm Mailing List', 'Upload Signature File', 'Edit Letter', 'Ready'];
    
    if (!app.user.group.isSuper) {
        steps = ['Create Campaign', 'Upload Mailing List', 'Define Column Mapping', 'Confirm Mailing List', 'Upload Signature File'];
    }

    if (campaignId > 0) {
        steps[0] = 'Edit Campaign';
    }

    const getSteps = () => {
        let results = [];

        steps.forEach((step, index) => {
            if (currentStep != index) {
                if (index != 4) {
                    results.push(<StepWrapper>{steps[index]}</StepWrapper>);
                } else {
                    results.push(<StepWrapper>{steps[index]}&nbsp;<span style={{ fontSize: 10 }}>(optional)</span></StepWrapper>);
                }
            } else {
                if (index != 4) {
                    results.push(<StepWrapper><strong>{steps[index]}</strong></StepWrapper>);
                } else {
                    results.push(<StepWrapper><strong>{steps[index]}</strong>&nbsp;<span style={{ fontSize: 10 }}>(optional)</span></StepWrapper>);
                }
            }

            if (index < steps.length - 1) {
                results.push(<ArrowWrapper><Glyphicon glyph='forward' /></ArrowWrapper>);
            }
        });

        return results;
    };

    return (
        <div className='text-center' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12 }}>
            <div style={{ marginRight: 10 }}>Steps for a mailing campaign:</div>{getSteps()}
        </div>
    );
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
       
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(CampaignSteps);